module.exports = "/images/logo.png?46331d9c4b6d629f844938acb1eef76e";